import { Component, Input } from '@angular/core';
import { NgbActiveModal }  from '@ng-bootstrap/ng-bootstrap';

import { ApiService }          from '../api/api.service';
import { MessagesService }     from '../messages/messages.service';
import { StreamSearchService } from '../api/stream-search.service';

@Component({
  selector: 'wor-vehicle-transfer-owner',
  template: `
    <form class="form-horizontal" novalidate #form="ngForm" (ngSubmit)="confirm()">
      <div class="modal-header clearfix">
        <h2 translate="VEHICLE_SPACE.TRANSFER_OWNERSHIP_OF_VEHICLE"></h2>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-sm-12">
            <label class="control-label" translate="CUSTOMER_SPACE.CURRENT_CUSTOMER"></label>
          </div>
        </div>
        <div class="row top-buffer info">
          <div class="col-sm-6">
            <p>{{ customer?.display_name }}</p>
            <p>{{ customer?.address1 }} {{ customer?.address2 }}</p>
            <p>{{ customer?.suburb }} {{ customer?.state }} {{ customer?.postcode }}</p>
          </div>
          <div class="col-sm-6">
            <p><i class="fa fa-phone"></i> {{ customer?.phone | phone }}</p>
            <p><i class="fa fa-mobile"></i> {{ customer?.mobile | mobilePhone }}</p>
            <p><i class="fa fa-envelope"></i> {{ customer?.email }}</p>
          </div>
        </div>
        <div class="row"><hr></div>
        <div class="row">
          <fieldset class="col-sm-6">
            <label class="control-label" for="customer" translate="CUSTOMER_SPACE.NEW_CUSTOMER"></label>
            <div class="controls autocomplete">
              <wor-typeahead-control
                [(model)]="selected"
                [searchFn]="searchCustomers.bind(this)"
                [formatterFn]="formatCustomer.bind(this)"
                (onSelect)="chooseCustomer($event)"
                [placeholder]="'CUSTOMER_SPACE.CHOOSE_A_CUSTOMER' | translate">
              </wor-typeahead-control>
            </div>
          </fieldset>
        </div>
        <div class="row top-buffer info" *ngIf="selected?.id">
          <div class="col-sm-6">
            <p>{{ selected?.address1 }} {{ selected?.address2 }}</p>
            <p>{{ selected?.suburb }} {{ selected?.state }} {{ selected?.postcode }}</p>
          </div>
          <div class="col-sm-6">
            <p><i class="fa fa-phone"></i> {{ selected?.phone | phone }}</p>
            <p><i class="fa fa-mobile"></i> {{ selected?.mobile | mobilePhone }}</p>
            <p><i class="fa fa-envelope"></i> {{ selected?.email }}</p>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="row">
          <div class="col-sm-4 text-left">
            <button type="button" class="btn btn-cancel"
              (click)="modal.dismiss()"
              translate="GENERAL_SPACE.BUTTON.CANCEL">
            </button>
          </div>
          <div class="col-sm-4 pull-right text-right">
            <button type="submit" class="btn btn-success"
              [disabled]="!selected?.id"
              translate="GENERAL_SPACE.BUTTON.CONFIRM">
            </button>
          </div>
        </div>
      </div>
    </form>
  `
})
export class VehicleTransferOwnerComponent {
  @Input() customer: any;
  @Input() vehicle: any;

  searchList: any[] = [];
  selected: any = null;

  constructor (
    public  modal               : NgbActiveModal,
    private apiService          : ApiService,
    private messagesService     : MessagesService,
    private streamSearchService : StreamSearchService
  ) {}

  formatCustomer (customer: any): string {
    return customer ? customer.display_name : '';
  }

  searchCustomers (typed: string): Promise<any> {
    return this.streamSearchService.search('customers', typed)
      .then((customers: any[]) => this.searchList.concat(customers));
  }

  chooseCustomer (customer: any): void {
    this.selected = customer;
  }

  confirm (): void {
    this.apiService.get('vehicles/change_owner', [this.vehicle.id, this.selected.id])
      .then(vehicle => this.modal.close(vehicle))
      .catch(err => this.messagesService.error(err));
  }
}
